import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-icon">
        <FontAwesomeIcon
          onClick={() => {
            const win = window.open(
              'https://pressplaylabs.notion.site/Storylines-Help-Center-d6d5e415e76242e9944c75229487b56f',
              '_blank',
            );
            win?.focus();
          }}
          className="question-circle-icon"
          icon={faQuestionCircle}
        />
      </div>
    </div>
  );
};

export default Footer;
